// Section with Editor
$(document).on('shopify:section:load', function(e){ 
  $('#' + e.target.id).find('[data-section]').sectionJs();
}).ready(function() {
  $('[data-section]').each(function(){ $(this).sectionJs() });
});

$.fn.sectionJs = function(){
  var $this = this;
  if($this.data('section') == "SlideShow") {
    $this.find('.hero-slider-active').SlideShow();
  }else if($this.data('section') == "TabWithProduct") {
    $this.find('.product-carousel-4').TabWithProduct();
  }else if($this.data('section') == "CollectionBanner") {
    $this.find('.product-banner-carousel').CollectionBanner();
  }else if($this.data('section') == "FeatureCollection") {
    $this.find('.product-carousel-4_2').FeatureCollectionActive();
  }else if($this.data('section') == "TestimonialSection") {
    $this.find('.testimonial-content-carousel').TestimonialContent();
    $this.find('.testimonial-thumb-carousel').TestimonialThumb();
  }else if($this.data('section') == "BannerWithCollection") {
    $this.BannerWithCollection();
  }else if($this.data('section') == "LatestBlog") {
    $this.find('.blog-carousel-active').LatestBlog();
  }else if($this.data('section') == "BrandLogo") {
    $this.find('.brand-logo-carousel').BrandLogoActive();
  }else if($this.data('section') == "CollectionThumbnail") {
    $this.find('.group-list-carousel--3').CollectionThumbnail();
  }else if($this.data('section') == "HotDeals") {
    $this.find('.deals-carousel-active').HotDeals();
  }else if($this.data('section') == "CollectionBannerSlideshow") {
    $this.find('.hero-slider-active-4').CollectionBannerSlideshow();
  }else if($this.data('section') == "RelatedProduct") {
    $this.find('.product-carousel-5').RelatedProduct();
  }else if($this.data('section') == "CustomCollection") {
    $this.find('.product-carousel-6').CustomCollection();
  }else if($this.data('section') == "HeaderSection") {
    $this.HeaderSection();
  }else if($this.data('section') == "CollectionTemplate") {
    $this.CollectionTemplateActivation();
  }else if($this.data('section') == "InstagramSlider") {
    $this.InstagramSection();
  }else if($this.data('section') == "ProductTemplate") {
    $this.ProductTemplate();
  }else if($this.data('section') == "MultipleBanner") {
    $this.MultipleBanner();
  }else if($this.data('section') == "FooterSection") {
    $this.FooterSection();
  }else if($this.data('section') == "AboutInfo") {
    $this.AboutInfo();
  }else if($this.data('section') == "TeamMember") {
    $this.TeamMember();
  }else if($this.data('section') == "BlogTemplate") {
    $this.BlogTemplate();
  }else if($this.data('section') == "ArticleTemplate") {
    $this.BlogTemplate();
  }else{}   
}

// Slideshow active js
$.fn.SlideShow = function() {
  var $SlideShowVAR = this;
  $SlideShowVAR.slick({
    fade: true,
    speed: 1000,
    dots: false,
    autoplay: false,prevArrow: '<button type="button" class="slick-prev"><i class="pe-7s-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="pe-7s-angle-right"></i></button>',responsive: [{
      breakpoint: 992,
      settings: {
        arrows: false,
        dots: true
      }
    }]
  });
  // Background Image JS start
  var bgSelector = $(".bg-img");
  bgSelector.each(function (index, elem) {
    var element = $(elem),
        bgSource = element.data('bg');
    element.css('background-image', 'url(' + bgSource + ')');
  });
};

// Tab With Product active js
$.fn.TabWithProduct = function() {
  var $TabWithProductVAR = this;
  $TabWithProductVAR.slick({
    speed: 1000,
    adaptiveHeight: true,prevArrow: '<button type="button" class="slick-prev"><i class="pe-7s-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="pe-7s-angle-right"></i></button>',});
  $("img.lazyload").lazyload();
};

// product banner active js
$.fn.CollectionBanner = function() {
  var $CollectionBannerVAR = this;
  $CollectionBannerVAR.slick({
    speed: 1000,
    arrows: false,});
  $("img.lazyload").lazyload();
};

// Featured Collection active js
$.fn.FeatureCollectionActive = function() {
  var $FeatureCollectionActiveVAR = this;
  if($FeatureCollectionActiveVAR.length > 0){
    $FeatureCollectionActiveVAR.slick({
      speed: 1000,
      adaptiveHeight: true,prevArrow: '<button type="button" class="slick-prev"><i class="pe-7s-angle-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="pe-7s-angle-right"></i></button>',});
  };
  $("img.lazyload").lazyload();
};

// Testimonial active js
$.fn.TestimonialContent = function() {
  var $TestimonialContentVAR = this;
  $TestimonialContentVAR.slick({
    arrows: false,
    asNavFor: '.testimonial-thumb-carousel',});
};
$.fn.TestimonialThumb = function() {
  var $TestimonialThumbVAR = this;
  $TestimonialThumbVAR.slick({
    slidesToShow: 3,
    asNavFor: '.testimonial-content-carousel',
    centerMode: true,
    arrows: false,centerPadding: 0,
    focusOnSelect: true
  });
};

// Banner with collection active js
$.fn.BannerWithCollection = function() {
  $('.group-list-carousel').each(function () {
    var $this = $(this);
    var $arrowContainer = $(this).parent().siblings('.section-title-append').find('.slick-append');
    $this.slick({
      infinite: true,prevArrow: '<button type="button" class="slick-prev"><i class="pe-7s-angle-left"></i></button>',
      nextArrow: '<button type="button" class="slick-next"><i class="pe-7s-angle-right"></i></button>',appendArrows: $arrowContainer
    });
  });
  $("img.lazyload").lazyload();
};

// Latest blog active js
$.fn.LatestBlog = function() {
  var $LatestBlogVAR = this;
  $LatestBlogVAR.slick({
    speed: 1000,
    adaptiveHeight: true,prevArrow: '<button type="button" class="slick-prev"><i class="pe-7s-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="pe-7s-angle-right"></i></button>',});
  $("img.lazyload").lazyload();
};

// Brand logo active js
$.fn.BrandLogoActive = function() {
  var $BrandLogoVAR = this;
  $BrandLogoVAR.slick({
    speed: 1000,
    adaptiveHeight: true,prevArrow: '<button type="button" class="slick-prev"><i class="pe-7s-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="pe-7s-angle-right"></i></button>',});
  $("img.lazyload").lazyload();
};

// Collection Thumbnail active js
$.fn.CollectionThumbnail = function() {
  var $CollectionThumbnailVAR = this;
  $CollectionThumbnailVAR.slick({
    speed: 1000,
    adaptiveHeight: true,prevArrow: '<button type="button" class="slick-prev"><i class="pe-7s-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="pe-7s-angle-right"></i></button>',});
  $("img.lazyload").lazyload();
};

// Hot Deal active js
$.fn.HotDeals = function() {
  var $HotDealsVAR = this;
  $HotDealsVAR.slick({
    speed: 1000,
    adaptiveHeight: false,prevArrow: '<button type="button" class="slick-prev"><i class="pe-7s-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="pe-7s-angle-right"></i></button>',});
  $("img.lazyload").lazyload();
};

// Collection Banner active js
$.fn.CollectionBannerSlideshow = function() {
  var $CollectionBannerSlideshowVAR = this;
  $CollectionBannerSlideshowVAR.slick({
    speed: 1000,
    arrows: false,});
  $("img.lazyload").lazyload();
};

// Related Product active js
$.fn.RelatedProduct = function() {
  var $RelatedProductVAR = this;
  $RelatedProductVAR.slick({
    speed: 1000,
    adaptiveHeight: false,prevArrow: '<button type="button" class="slick-prev"><i class="pe-7s-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="pe-7s-angle-right"></i></button>',});
  $("img.lazyload").lazyload();
};

// Related Product active js
$.fn.CustomCollection = function() {
  var $CustomCollectionVAR = this;
  $CustomCollectionVAR.slick({
    speed: 1000,
    adaptiveHeight: false,prevArrow: '<button type="button" class="slick-prev"><i class="pe-7s-angle-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="pe-7s-angle-right"></i></button>',});
  $("img.lazyload").lazyload();
};

// Paged carousel with dots (window.DotPager): a native horizontal scroll
// ([data-pager-track]) with CSS snap points on the first item of each page,
// so the finger moves one page at a time; this keeps the dots
// ([data-pager-dot], .is-active and aria-current) in sync with the scroll
// and makes them clickable. A page is the track's width plus one gap; at
// the end of the scroll the last dot is active (an odd last page shows the
// last two items). Today: the photo slider of the mobile side menu
// (snippets/header-nav-mega.liquid) and the search page's shortcuts, whose
// dots search-filters.js builds and changes with setDots() (how many
// depends on the width). It's the same logic as Pager in home-page.js (the
// home page's categories), which only loads on the home page; this file
// loads on every page before it, so Pager can switch to DotPager later.
// Until then, change both together (setDots() is only here).
window.DotPager = (function () {
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function DotPager(root) {
    this.track = root.querySelector('[data-pager-track]');
    this.dots = root.querySelectorAll('[data-pager-dot]');
    this.ticking = false;
    if (!this.track) return;

    var self = this;
    this.track.addEventListener('scroll', function () {
      if (self.ticking) return;
      self.ticking = true;
      window.requestAnimationFrame(function () {
        self.ticking = false;
        self.update();
      });
    }, { passive: true });
    for (var i = 0; i < this.dots.length; i++) {
      this.dots[i].addEventListener('click', this.goTo.bind(this, i));
    }
    this.update();
  }

  DotPager.prototype.pageWidth = function () {
    var gap = parseFloat(window.getComputedStyle(this.track).columnGap) || 0;
    return this.track.clientWidth + gap;
  };

  DotPager.prototype.current = function () {
    var t = this.track;
    var max = t.scrollWidth - t.clientWidth;
    if (max <= 0) return 0;
    if (t.scrollLeft >= max - 2) return Math.max(this.dots.length - 1, 0);
    return Math.round(t.scrollLeft / this.pageWidth());
  };

  DotPager.prototype.update = function () {
    var page = this.current();
    for (var i = 0; i < this.dots.length; i++) {
      var on = i === page;
      this.dots[i].classList.toggle('is-active', on);
      if (on) {
        this.dots[i].setAttribute('aria-current', 'true');
      } else {
        this.dots[i].removeAttribute('aria-current');
      }
    }
  };

  // The last page can be shorter than a full page: never past the end
  DotPager.prototype.goTo = function (page) {
    var t = this.track;
    t.scrollTo({
      left: Math.min(page * this.pageWidth(), t.scrollWidth - t.clientWidth),
      behavior: reducedMotion.matches ? 'auto' : 'smooth'
    });
  };

  // Other dots, e.g. after the carousel's width changed its page count
  DotPager.prototype.setDots = function (dots) {
    this.dots = dots;
    for (var i = 0; i < dots.length; i++) {
      dots[i].addEventListener('click', this.goTo.bind(this, i));
    }
    this.update();
  };

  // Back to the first page at once
  DotPager.prototype.reset = function () {
    if (!this.track) return;
    this.track.scrollLeft = 0;
    this.update();
  };

  return DotPager;
})();

// Accordion (window.ThemeAccordion): a button with aria-expanded and
// aria-controls, and its panel. Open: .is-open on the panel, not inert;
// closed: inert (no focus, no screen reader). The height transition is CSS
// (.site-nav-m__panel in header.css, .site-footer__panel in footer.css).
// Used by the mobile side menu (HeaderSection) and the footer's menus on
// mobile (FooterSection).
window.ThemeAccordion = {
  set: function (toggle, open) {
    if (!toggle) return;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    var panel = document.getElementById(toggle.getAttribute('aria-controls'));
    if (!panel) return;
    panel.classList.toggle('is-open', open);
    if (open) {
      panel.removeAttribute('inert');
    } else {
      panel.setAttribute('inert', '');
    }
  },

  isOpen: function (toggle) {
    return !!toggle && toggle.getAttribute('aria-expanded') === 'true';
  }
};

// Header Section active js
// Runs again every time the theme editor re-renders the header, so every
// handler is namespaced (.header) and unbound first: a second handler on a
// toggle undid the first one (the search box opened and closed at once).
$.fn.HeaderSection = function() {
  var $window = $(window);
  var $document = $(document);

  // Side menu scroll lock (see "Off Canvas Open close"). If the theme editor
  // re-renders the header while the menu is open, the page is released first.
  var scrollLocked = false;
  var lockedY = 0;
  if (document.documentElement.classList.contains('hd-scroll-lock')) {
    var stuckY = -parseFloat(document.body.style.top) || 0;
    document.documentElement.classList.remove('hd-scroll-lock');
    document.body.style.top = '';
    window.scrollTo(0, stuckY);
  }

  // The cart buttons (.minicart-btn, links to the cart page) open the mini
  // cart: assets/mini-cart.js (sections/mini-cart.liquid), not here.

  // Search boxes: desktop (.search-trigger → .header-search-box, shown with
  // .search-box-open) and mobile (.mobile-search-trigger → the box below the
  // bar, hidden attribute). Each button points to its box with
  // aria-controls. Opening focuses the field; Esc or a click outside closes.
  var $searchTriggers = $(".search-trigger, .mobile-search-trigger");

  function setSearch($trigger, open) {
    var $box = $('#' + $trigger.attr('aria-controls'));
    if (!$box.length) return;
    if ($box.hasClass('header-search-box')) {
      $box.toggleClass('search-box-open', open);
    } else {
      $box.prop('hidden', !open);
    }
    $trigger.attr('aria-expanded', open ? 'true' : 'false');
    if (open) $box.find('input[name="q"]').trigger('focus');
  }

  $searchTriggers.off('click.header').on('click.header', function(){
    var $trigger = $(this);
    setSearch($trigger, $trigger.attr('aria-expanded') !== 'true');
  });

  $document.off('click.header').on('click.header', function(e){
    $searchTriggers.each(function(){
      var $trigger = $(this);
      if ($trigger.attr('aria-expanded') !== 'true') return;
      var box = document.getElementById($trigger.attr('aria-controls'));
      if (this.contains(e.target) || (box && box.contains(e.target))) return;
      setSearch($trigger, false);
    });
  });

  $document.off('keydown.header').on('keydown.header', function(e){
    if (e.key !== 'Escape') return;
    $searchTriggers.each(function(){
      var $trigger = $(this);
      if ($trigger.attr('aria-expanded') !== 'true') return;
      setSearch($trigger, false);
      $trigger.trigger('focus');
    });
  });

  // Sticky menu
  // .sticky.is-sticky is position: fixed, so it leaves the page flow and
  // everything below used to move up by its height (the page jumped).
  // A placeholder right before each .sticky keeps that height while it's fixed.
  // On desktop the .sticky is the whole main block of the header (header.css
  // turns it into the compact bar once fixed), on mobile the mobile header.
  // Without "Header Sticky Enable" there is no .sticky and nothing happens.
  var $sticky = $(".sticky");
  $sticky.each(function () {
    if (!$(this).prev().hasClass("sticky-placeholder")) {
      $('<div class="sticky-placeholder" aria-hidden="true"></div>').insertBefore(this);
    }
  });

  // Height in the page flow, margins included. 0 when hidden (the mobile
  // header on desktop, the desktop header on mobile)
  function flowHeight(el) {
    var height = el.getBoundingClientRect().height;
    if (!height) return 0;
    var style = window.getComputedStyle(el);
    return height + (parseFloat(style.marginTop) || 0) + (parseFloat(style.marginBottom) || 0);
  }

  function setSticky(on) {
    $sticky.each(function () {
      var $el = $(this);
      if (on === $el.hasClass("is-sticky")) return;
      var $placeholder = $el.prev(".sticky-placeholder");
      if (on) {
        // Measured before it becomes fixed
        $placeholder.css("height", flowHeight(this) + "px");
        $el.addClass("is-sticky");
      } else {
        $el.removeClass("is-sticky");
        $placeholder.css("height", "");
      }
    });
  }

  function updateSticky() {
    // While the side menu locks the page (below), the fixed body resets the
    // scroll to 0: ignore it, so the header doesn't move behind the menu
    if (scrollLocked) return;
    setSticky($window.scrollTop() >= 300);
  }

  $window.off('scroll.header').on('scroll.header', updateSticky);

  // Desktop and mobile headers have different heights: measure again when
  // the width changes. Only the width: mobile browsers fire resize when
  // their address bar shows or hides while scrolling
  var stickyWidth = $window.width();
  $window.off('resize.header').on('resize.header', function () {
    // The side menu only exists below 992px
    if (window.matchMedia('(min-width: 992px)').matches) closeMobileMenu();
    fitMegaPanel();
    if (scrollLocked) return;
    if ($window.width() === stickyWidth) return;
    stickyWidth = $window.width();
    setSticky(false);
    updateSticky();
  });

  // Also when the page loads already scrolled (back button, reload)
  updateSticky();

  // Off Canvas Open close
  // Only the side menu scrolls (header.css). The page behind is locked: iPhone
  // Safari still scrolls it with overflow: hidden on body, so the body
  // becomes fixed at the current scroll (html.hd-scroll-lock, top set
  // inline) and goes back to it on close. The fixed header stays put (it's
  // position: fixed, and updateSticky ignores the scroll while locked); a
  // header that isn't fixed moves with the body, so nothing jumps either.
  // Every way out unlocks: the X, the overlay, Esc, a link in the menu and
  // a window that grows to desktop. The X, the overlay and Esc (and the
  // swipe, assets/sheet-drag.js, which clicks the X) give the focus back to
  // the menu button, without scrolling. body.fix has no CSS in the theme; it
  // stays as it was.
  function lockScroll() {
    if (scrollLocked) return;
    lockedY = window.pageYOffset || document.documentElement.scrollTop || 0;
    scrollLocked = true;
    document.body.style.top = (-lockedY) + 'px';
    document.documentElement.classList.add('hd-scroll-lock');
  }

  function unlockScroll() {
    if (!scrollLocked) return;
    var html = document.documentElement;
    var behavior = html.style.scrollBehavior;
    html.classList.remove('hd-scroll-lock');
    document.body.style.top = '';
    // Straight back to the same point, never a smooth scroll
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, lockedY);
    html.style.scrollBehavior = behavior;
    scrollLocked = false;
    // A width change while locked (rotation) wasn't measured: do it now
    if ($window.width() !== stickyWidth) {
      stickyWidth = $window.width();
      setSticky(false);
    }
    updateSticky();
  }

  function openMobileMenu() {
    // Its accordions (.site-nav-m) always start closed, and the photo
    // sliders on their first page. At once: .is-instant turns off the
    // transitions until the styles are applied (offsetWidth)
    var nav = document.querySelector('.off-canvas-wrapper .site-nav-m');
    if (nav) nav.classList.add('is-instant');
    $('.site-nav-m [data-nav-m-toggle]').each(function () {
      setMobileNavToggle($(this), false);
    });
    $('.site-nav-m [data-dot-pager]').each(function () {
      if (this.dotPager) this.dotPager.reset();
    });
    if (nav) {
      void nav.offsetWidth;
      nav.classList.remove('is-instant');
    }
    $("body").addClass('fix');
    $(".off-canvas-wrapper").addClass('open');
    $(".mobile-menu-btn").attr('aria-expanded', 'true');
    lockScroll();
  }

  function closeMobileMenu(returnFocus) {
    if (!$(".off-canvas-wrapper").hasClass('open')) return;
    $("body").removeClass('fix');
    $(".off-canvas-wrapper").removeClass('open');
    $(".mobile-menu-btn").attr('aria-expanded', 'false');
    unlockScroll();
    // preventScroll: the page is back at its point; the header that isn't
    // fixed yet may be partly above it
    var button = document.querySelector('.mobile-menu-btn');
    if (returnFocus && button) button.focus({ preventScroll: true });
  }

  $(".mobile-menu-btn").off('click.header').on('click.header', openMobileMenu);

  $(".btn-close-off-canvas,.off-canvas-overlay").off('click.header').on('click.header', function () {
    closeMobileMenu(true);
  });

  // A link that leaves the menu (not the account and currency dropdowns of
  // Bootstrap: data-toggle, href="#")
  $(".off-canvas-wrapper").off('click.header').on('click.header', 'a[href]:not([href="#"]):not([data-toggle])', function () {
    closeMobileMenu();
  });

  $document.off('keydown.headerMenu').on('keydown.headerMenu', function (e) {
    if (e.key === 'Escape') closeMobileMenu(true);
  });

  // Menu (snippets/header-nav.liquid). Desktop (.site-nav): an item with a
  // panel has a button (the title, or the arrow next to a title link) with
  // aria-expanded. The panel also opens on hover (CSS, mouse only); .is-open
  // keeps it open. Opening one closes the others; Esc, Tab out of the item
  // or a click outside close it. Its own namespace (.headerNav): the
  // document handlers of .header above would be unbound by an .off().
  var $navItems = $('.site-nav [data-nav-item]');

  function setNavItem($item, open) {
    $item.toggleClass('is-open', open);
    $item.children('[data-nav-toggle]').attr('aria-expanded', open ? 'true' : 'false');
  }

  // Mega menu panels (snippets/header-nav-mega.liquid): the list of cards
  // and the preview of the active one. Every preview is rendered, stacked,
  // and only .is-active shows (header.css): the list item and its preview
  // share data-mega-index. Hover or focus on a list item makes it active,
  // and it stays active after the mouse leaves the list. A panel always
  // opens on its first card.
  function setMegaActive($item, index) {
    index = String(index);
    $item.find('[data-mega-index]').each(function () {
      this.classList.toggle('is-active', this.getAttribute('data-mega-index') === index);
    });
  }

  // The panel's max-height (--nav-panel-max): the room left below the
  // header, so a tall panel scrolls inside instead of going off screen.
  // The header moves (fixed bar, scroll), so it's measured on open, on
  // scroll while a panel shows and on resize.
  function fitMegaPanel() {
    var main = document.querySelector('.site-header .site-header__main');
    if (!main || !main.getBoundingClientRect().height) return;
    var room = window.innerHeight - main.getBoundingClientRect().bottom - 24;
    main.style.setProperty('--nav-panel-max', Math.max(Math.round(room), 240) + 'px');
  }

  function startMega($item) {
    if (!$item.hasClass('site-nav__item--mega')) return;
    setMegaActive($item, 0);
    fitMegaPanel();
  }

  $('.site-nav .site-nav-mega__item').off('pointerenter.headerNav focusin.headerNav').on('pointerenter.headerNav focusin.headerNav', function () {
    setMegaActive($(this).closest('[data-nav-item]'), this.getAttribute('data-mega-index'));
  });

  $window.off('scroll.headerNav').on('scroll.headerNav', function () {
    if (document.querySelector('.site-nav__item--mega.is-open, .site-nav__item--mega:hover')) fitMegaPanel();
  });

  function closeNavItems($except) {
    $navItems.each(function () {
      var $item = $(this);
      if ($except && $item.is($except)) return;
      if ($item.hasClass('is-open')) setNavItem($item, false);
    });
  }

  $navItems.children('[data-nav-toggle]').off('click.headerNav').on('click.headerNav', function () {
    var $item = $(this).parent();
    var open = !$item.hasClass('is-open');
    closeNavItems($item);
    setNavItem($item, open);
    if (open) startMega($item);
  });

  // Tab out of the item (a click elsewhere has no relatedTarget: the
  // document click below handles it)
  $navItems.off('focusout.headerNav').on('focusout.headerNav', function (e) {
    if (!e.relatedTarget || this.contains(e.relatedTarget)) return;
    setNavItem($(this), false);
  });

  // The mouse on another item opens its panel by hover: close the one
  // opened with its button. One opened with its button keeps its active
  // card when the mouse comes in.
  $navItems.off('pointerenter.headerNav').on('pointerenter.headerNav', function (e) {
    if (e.pointerType !== 'mouse') return;
    var $item = $(this);
    closeNavItems($item);
    if (!$item.hasClass('is-open')) startMega($item);
  });

  $document.off('click.headerNav').on('click.headerNav', function (e) {
    if ($(e.target).closest('.site-nav [data-nav-item]').length) return;
    closeNavItems();
  });

  $document.off('keydown.headerNav').on('keydown.headerNav', function (e) {
    if (e.key !== 'Escape') return;
    var $open = $navItems.filter('.is-open');
    if (!$open.length) return;
    setNavItem($open, false);
    $open.children('[data-nav-toggle]').first().trigger('focus');
  });

  // Theme editor: selecting a mega menu or card block opens its panel; a
  // card also becomes the active one (its list item has the block's
  // attributes and its data-mega-index)
  $document.off('shopify:block:select.headerNav').on('shopify:block:select.headerNav', function (e) {
    var $item = $(e.target).closest('.site-nav [data-nav-item]');
    if (!$item.length) return;
    closeNavItems($item);
    setNavItem($item, true);
    startMega($item);
    var index = $(e.target).closest('[data-mega-index]').attr('data-mega-index');
    if (index !== undefined) setMegaActive($item, index);
  });

  $document.off('shopify:block:deselect.headerNav').on('shopify:block:deselect.headerNav', function () {
    closeNavItems();
  });

  // Mobile side menu (.site-nav-m): every title with a submenu is an
  // accordion button (window.ThemeAccordion, above). Its panel opens with
  // .is-open (a height transition, header.css) and is inert while closed:
  // out of the tab order and of the screen reader. Several can be open at
  // once.
  function setMobileNavToggle($toggle, open) {
    window.ThemeAccordion.set($toggle[0], open);
  }

  // The photo sliders of the side menu (window.DotPager, above)
  $('.site-nav-m [data-dot-pager]').each(function () {
    if (!this.dotPager) this.dotPager = new window.DotPager(this);
  });

  $('.site-nav-m [data-nav-m-toggle]').off('click.header').on('click.header', function () {
    var $toggle = $(this);
    setMobileNavToggle($toggle, $toggle.attr('aria-expanded') !== 'true');
  });

  // Wishlist count (.wishlist-item-count: desktop heart and "Mis deseados"
  // in the side menu) on every page: wishlist.js, which also updates it after
  // each change, only loads on pages with hearts. Same list (localStorage
  // user_wishlist) and rule (hidden at 0) as updateWishlistItemCount() in
  // wishlist.js: change both together.
  var wishlistCount = 0;
  try {
    var savedWishlist = JSON.parse(window.localStorage.getItem('user_wishlist') || '[]');
    if ($.isArray(savedWishlist)) wishlistCount = savedWishlist.length;
  } catch (err) {}
  $('.wishlist-item-count').text(wishlistCount).prop('hidden', wishlistCount === 0);

  $("img.lazyload").lazyload();
};

// Collection Template active js
$.fn.CollectionTemplateActivation = function() {
  // product view mode change js
  $('.product-view-mode a').on('click', function (e) {
    e.preventDefault();
    var shopProductWrap = $('.shop-product-wrap');
    var viewMode = $(this).data('target');
    $('.product-view-mode a').removeClass('active');
    $(this).addClass('active');
    shopProductWrap.removeClass('grid-view list-view').addClass(viewMode);
  });
  $("img.lazyload").lazyload();
};

// Instgram active js
$.fn.InstagramSection = function(){
  var activation = this.find('[data-username]'),
      activeId = activation.attr('id'),
      clientUsername = activation.attr('data-username'),
      instagramHastag = activation.attr('data-hashtag'),
      ItemsLimit = activation.attr('data-limit'),
      imageSize = activation.attr('data-size'),
      instaslider = ".instagram-carousel";

  $.instagramFeed({
    'tag': instagramHastag,
    'username': clientUsername,
    'container': "#"+activeId,
    'display_profile': false,
    'display_biography': false,
    'display_gallery': true,
    'styling': false,
    'items': ItemsLimit,
    'margin': 1,
    'image_size': imageSize
  });

  var $instagramNews = "#"+activeId+instaslider,
      $slidesToShow = activation.data('slidetoshow'),
      $slideshowtablet = activation.data('slideshowtablet'),
      $slideshowsmmobile = activation.data('slideshowsmmobile');

  $($instagramNews).on("DOMNodeInserted", function (e) {
    if (e.target.className == 'instagram_gallery') {
      $("." + e.target.className).slick({
        slidesToShow: $slidesToShow,
        slidesToScroll: 1,
        
        dots: false,
        arrows: false,
        responsive: [
          {
            breakpoint: 480,
            settings: {
              slidesToShow: $slideshowsmmobile,
            }
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: $slideshowtablet,
            }
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: $slideshowtablet,
            }
          }

        ]
      })
    }
  });  
};

// Product Template active js
$.fn.ProductTemplate = function() {
  // Thumbnail strip is native scroll now (assets/product-gallery.js), no Slick
  $("img.lazyload").lazyload();
};

// Multiple Banner active js
$.fn.MultipleBanner = function() {
  $("img.lazyload").lazyload();
};

// Footer Section active js
// Footer (sections/footer.liquid). On mobile (≤ 767px) its two menus are
// accordions (window.ThemeAccordion), closed when the page loads; from
// 768px they are plain columns: open, never inert, and their buttons are
// hidden (footer.css). The layout is applied again when the width crosses
// 768px. Runs again when the theme editor re-renders the footer: handlers
// namespaced (.footer), and the previous width listener removed.
$.fn.FooterSection = function() {
  var root = this[0];
  var mobile = window.matchMedia('(max-width: 767px)');
  var toggles = root ? root.querySelectorAll('[data-footer-toggle]') : [];

  function applyLayout() {
    for (var i = 0; i < toggles.length; i++) {
      if (mobile.matches) {
        window.ThemeAccordion.set(toggles[i], false);
      } else {
        toggles[i].setAttribute('aria-expanded', 'false');
        var panel = document.getElementById(toggles[i].getAttribute('aria-controls'));
        if (panel) {
          panel.classList.remove('is-open');
          panel.removeAttribute('inert');
        }
      }
    }
  }

  $(toggles).off('click.footer').on('click.footer', function () {
    window.ThemeAccordion.set(this, !window.ThemeAccordion.isOpen(this));
  });

  // One width listener at a time: the previous one is removed from its own
  // MediaQueryList (matchMedia returns a new one on every call).
  // addListener / removeListener: Safari before 14
  var previous = window.FooterSectionLayout;
  if (previous) {
    if (previous.mql.removeEventListener) {
      previous.mql.removeEventListener('change', previous.fn);
    } else {
      previous.mql.removeListener(previous.fn);
    }
  }
  window.FooterSectionLayout = { mql: mobile, fn: applyLayout };
  if (mobile.addEventListener) {
    mobile.addEventListener('change', applyLayout);
  } else {
    mobile.addListener(applyLayout);
  }
  applyLayout();

  // Theme editor: selecting a menu block on mobile opens its accordion
  $(document).off('shopify:block:select.footer').on('shopify:block:select.footer', function (e) {
    if (!mobile.matches || !e.target.querySelector) return;
    var toggle = e.target.querySelector('[data-footer-toggle]');
    if (toggle) window.ThemeAccordion.set(toggle, true);
  });

  $("img.lazyload").lazyload();
};

// About section active js
$.fn.AboutInfo = function() {
  $("img.lazyload").lazyload();
};

// Team member section active js
$.fn.TeamMember = function() {
  $("img.lazyload").lazyload();
};

// Blog template active js
$.fn.BlogTemplate = function() {
  $("img.lazyload").lazyload();
};

// Article template active js
$.fn.ArticleTemplate = function() {
  $("img.lazyload").lazyload();
};


(function($) {
  "use strict";

  jQuery(document).ready(function(){
    // All jQuery activation code paste here    
    
    

	// tooltip active js
	$('[data-toggle="tooltip"]').tooltip();

    // Touch screens (the same condition as in product-card.css): no tooltip on the photo buttons of the card grid
    // (compare, quick view; the heart has none, plainHearts()): after a tap
    // it stayed stuck. Checked each time a tooltip is about to show, not once
    // on load (the page can change: the browser's device mode, a tablet with
    // a mouse). Listened from the document, so it also covers the cards
    // added later (filters, product tabs, related products)
    $(document).on('show.bs.tooltip', '.cc-grid .button-group', function (event) {
      if (window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches) {
        event.preventDefault();
      }
    });

    
    // Product grid color variant activation code. 
    $('.product-color li label').click(function(){
      var variantImage = jQuery(this).parent().find('.hidden a').attr('href');
      jQuery(this).parents('.product-wrapper').find('.popup_cart_image').attr({ src: variantImage }); 
      return false;
    });

  });
  
})(jQuery);